
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projets/[slug]",
      function () {
        return require("private-next-pages/projets/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projets/[slug]"])
      });
    }
  